import React, { useEffect } from 'react';
import RequirementsPanel from './RequirementsPanel';
import RequirementsSummary from './RequirementsSummary';
import { audienceRequirementsBackend } from './flags';
import { AudienceGroups, ReqModule, dummyView } from './requirements';
import { closeRequirements, useAudienceRequirements, useOpenRequirementsScope } from './useRequirements';

/**
 * Mounted once by the lesson editor: the grid when the designer header opens
 * it, or one lesson's summary when its icon does. With the backend on, both
 * draw what GET programs/{id}/audienceRequirements says, read as they open.
 * DUMMY until then: the editor's lessons and the groups made up for them.
 */
const RequirementsHost: React.FC<{
  grpId: string;
  /** The lesson open in the editor, for its summary's title. */
  lessonTitle?: string;
  /** DUMMY, while the backend is off: the editor's lessons and the made-up groups. */
  dummy: { modules: ReqModule[]; groups: AudienceGroups; loading: boolean } | null;
}> = ({ grpId, lessonTitle = '', dummy }) => {
  const scope = useOpenRequirementsScope();
  const backend = audienceRequirementsBackend();
  const server = useAudienceRequirements(grpId, backend && scope !== null);
  // Leaving the editor closes it, so it never reopens on another program.
  useEffect(() => () => closeRequirements(), []);
  if (!scope) return null;
  const view = backend ? server.view : dummy ? dummyView(dummy.modules, dummy.groups) : null;
  const loading = backend ? server.loading : Boolean(dummy?.loading);
  const error = backend ? server.error : null;
  return scope.kind === 'course' ? (
    <RequirementsPanel view={view} loading={loading} error={error} />
  ) : (
    <RequirementsSummary
      moduleId={scope.moduleId}
      lessonId={scope.lessonId}
      title={lessonTitle}
      view={view}
      loading={loading}
      error={error}
      live={backend}
    />
  );
};

export default RequirementsHost;
